export default __webpack_public_path__ + "static/media/bp_normal.62c9a057.svg";